export default __webpack_public_path__ + "static/media/ayuda-pdf.65f27150.svg";